export default {
  Auth: {
    AuthImage: 'احراز تصویری',
    CreatedAt: 'تاریخ درخواست احراز',
    ApprovedAt: 'تایید شده در تاریخ',
    RejectedAt: 'رد شده در تاریخ',
    By: 'توسط',
  },
}
